import { IMAGE_MIME_TYPES } from 'pages/Batch/configs';
import { getResizingParams } from 'pages/Batch/utils/index';

import type { IProcessResult } from './toolchain';

export const getTargetSizes = (originalWidth: number, originalHeight: number, width?: number, height?: number) => {
  if (width && height) {
    return [width, height];
  }

  let ratio = 1;
  if (width) {
    ratio = originalWidth / width;
  } else if (height) {
    ratio = originalHeight / height;
  }
  const resizedWidth = Math.round(originalWidth / ratio) || 0;
  const resizedHeight = Math.round(originalHeight / ratio) || 0;
  return [resizedWidth, resizedHeight];
};

export async function resizeImage(image: HTMLImageElement, width: number, height: number, usePadding = false, bgColor: string | null, texture?: HTMLImageElement): Promise<IProcessResult> {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  const isExactSize = width && height;
  const resizeWidth = width || image.width;
  const resizeHeight = height || image.height;

  let ratio;
  if (isExactSize) {
    const byWidth = image.width / resizeWidth;
    ratio = image.height / byWidth < resizeHeight ? byWidth : image.height / resizeHeight;
  } else {
    const resizeByHeight = !width && height;
    if (resizeByHeight) {
      ratio = image.height / resizeHeight;
    } else {
      ratio = image.width / resizeWidth;
    }
  }
  const newWidth = usePadding || !isExactSize ? image.width / ratio : resizeWidth;
  const newHeight = usePadding || !isExactSize ? image.height / ratio : resizeHeight;

  canvas.width = !isExactSize ? newWidth : resizeWidth;
  canvas.height = !isExactSize ? newHeight : resizeHeight;

  if (ctx && usePadding && isExactSize && bgColor) {
    ctx.fill();
    ctx.fillStyle = bgColor;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  }

  if (texture) {
    const { fromX, fromY, width: fWidth, height: fHeight } = getResizingParams(resizeWidth, resizeHeight, texture.width, texture.height);

    ctx?.drawImage(texture, fromX, fromY, fWidth || texture.width, fHeight || texture.height, 0, 0, resizeWidth, resizeHeight);
  }

  ctx?.drawImage(image, 0, 0, image.width, image.height, isExactSize ? (resizeWidth - newWidth) / 2 : 0, isExactSize ? (resizeHeight - newHeight) / 2 : 0, newWidth, newHeight);
  return new Promise(resolve => {
    canvas.toBlob(blob => blob && resolve({ blob, result: URL.createObjectURL(blob) }), IMAGE_MIME_TYPES.WEBP);
  });
}
